<div class="unauthorized-container">
  <div class="content">
    <div class="error-code">403</div>
    <h1>Unauthorized</h1>
    <p>You do not have access to this page.</p>
    <p class="sub-text">Contact your administrator if you believe this is an error.</p>

    <div class="actions">
      <button mat-raised-button color="primary" routerLink="/">Back to dashboard</button>
    </div>
  </div>
</div>
